"use strict";
/** @format */
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusBarConfigData = exports.imageUrlData = void 0;
const tslib_1 = require("tslib");
const imageUrlData = require("./imageUrl.json");
exports.imageUrlData = imageUrlData;
const statusBarConfigData = require("./statusBarConfig.json");
exports.statusBarConfigData = statusBarConfigData;
tslib_1.__exportStar(require("./badge-map"), exports);
